import React, { cloneElement, forwardRef, isValidElement, } from 'react';
import { Button } from '@tt/ui';
import { useProgressBar } from '../../context';
const SaveButton = forwardRef(({ asChild, children, ...rest }, ref) => {
    const { onSave } = useProgressBar();
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            onClick: onSave,
            ...children.props,
        });
    }
    return (React.createElement(Button, { ref: ref, size: "lg", variant: "ghost", onClick: onSave, ...rest }, children ?? 'Save'));
});
export default SaveButton;
